const config = require("../config")
module.exports = {
    credential: {
        url:  config.base_dev_url + "ali/mini_credential",
        type: "post",
    },
    uploadImg: {
        url:  config.base_dev_url + "lz_tree_image/insert",
        type: "post",
    },
    AIRecognize: {
        url: config.base_dev_url + "ai/image/recognize",
        type: "post",
    },
    //getTreeImageList
    getTreeImageList: {
        url: config.base_dev_url + "lz_tree_image/treeImageList",
        type: "post",
    },
    //findSuitabilityByPoint
    findSuitabilityByPoint: {
        url: config.base_dev_url + "lz_weather7d/findSuitabilityByPoint/{farmId}/{date}",
        type: "get",
    },
}
